"use client";

import { Link } from "react-router-dom";

function OfficePage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[5%] flex items-center justify-center">
      <div className="container">
        <div className="block md:flex md:justify-center gap-12 mb-4">
          <h1 className="text-2xl text-black font-medium md:w-1/2 lg:w-5/12 xl:w-1/3 h-auto ">
            Office
          </h1>
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit" />
        </div>
        <div className="block md:flex md:justify-center gap-12">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Hong Kong Office</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              Unit 411, 4/F, Hope Sea Industrial Centre, 26 Lam Hing Street,
              Kowloon Bay, Kowloon, Hong Kong​
            </div>
          </div>
          <img
            src="/images/office/1.jpg"
            alt="1"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Contact</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>Mobile: (852) 6825 1010</div>
              <div>Tel: (852) 2111 1417</div>
              <div>Email: wilson.wws55@gmail.com</div>
              <div>
                Website:{" "}
                <Link
                  to={"https://www.wwahk.com"}
                  className="text-blue-500"
                  target="_blank"
                >
                  www.wwahk.com
                </Link>
              </div>
            </div>
          </div>
          <img
            src="/images/office/2.jpg"
            alt="2"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Affiliate Business</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>Employment Agency - HKFullForce </div>
              <div>
                Website:{" "}
                <Link
                  to={"https://hkfullforce.com"}
                  target="_blank"
                  className="text-blue-500"
                >
                  hkfullforce.com
                </Link>
              </div>
            </div>
          </div>
          <div className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4" />
        </div>
      </div>
    </div>
  );
}

export default OfficePage;
